import { FC, memo } from 'react'
import { useNavigate } from 'react-router-dom'
import { useAppDispatch } from 'store'
import { FastConvert } from 'store/convert/hooks'
import {
  MarketIcon,
  MarketIconWrap,
  MarketItemWrap,
  MarketName,
} from './styles'
import { ConvertIcon } from 'components/ConvertIcon'
import { FlexItem } from 'styles'
import { updateModal } from '../../store/app/actions/modalActions'

export const ConvertItem: FC<{
  item: FastConvert
}> = memo(({ item }) => {
  const navigate = useNavigate()
  const dispatch = useAppDispatch()
  return (
    <MarketItemWrap
      onClick={() => {
        navigate(`/convert/${item.baseName}/${item.quoteName}`)
        dispatch(
          updateModal({
            modal: 'marketDrawer',
            open: false,
          })
        )
      }}>
      <MarketIconWrap>
        <MarketIcon src={item.icon} />
        <ConvertIcon />
      </MarketIconWrap>
      <FlexItem>
        <MarketName>{`${item.baseName}/${item.quoteName}`}</MarketName>
      </FlexItem>
    </MarketItemWrap>
  )
})
